import React from "react";
import { motion } from "framer-motion";
import { Petal, Waves } from "./Decor";
import { BrandSymbol } from "./BrandLogo";
import { useLang } from "../data/i18n";

export default function About() {
    const { t } = useLang();
    return (
        <section
            id="about"
            className="relative bg-lagoon-50 py-24 md:py-32 overflow-hidden"
            data-testid="about-section"
        >
            <BrandSymbol
                size={280}
                tint="ocean"
                className="absolute -top-16 -left-16 opacity-15"
            />
            <BrandSymbol
                size={220}
                tint="coral"
                className="absolute -bottom-12 -right-12 opacity-20"
            />

            <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="lg:col-span-5"
                    >
                        <p className="text-[11px] uppercase tracking-[0.3em] text-coral font-bold mb-5 flex items-center gap-3">
                            <span className="inline-block w-8 h-px bg-coral" />
                            {t.about.kicker}
                        </p>
                        <h2 className="font-serif font-normal text-ocean text-5xl md:text-6xl leading-[0.95] tracking-tight">
                            {t.about.titleA}
                            <br />
                            <em className="coral-italic">{t.about.titleB}</em>.
                        </h2>
                        <div className="mt-8">
                            <Waves className="w-40 h-6" color="#1B6CA8" />
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.15 }}
                        className="lg:col-span-7 space-y-5 text-ink/85 text-base md:text-lg leading-relaxed"
                    >
                        <p>
                            <span className="font-serif italic text-ocean text-2xl">
                                {t.about.brand}
                            </span>
                            {t.about.p1}
                        </p>
                        <p>{t.about.p2}</p>
                        <p>{t.about.p3}</p>
                        <p>{t.about.p4}</p>

                        <div className="pt-6 flex flex-wrap gap-3">
                            {t.about.tags.map((tag) => (
                                <Tag key={tag}>{tag}</Tag>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}

function Tag({ children }) {
    return (
        <span className="inline-flex items-center px-3 py-1.5 border-2 border-ocean/20 bg-cream text-ocean text-xs uppercase tracking-[0.2em] font-bold">
            {children}
        </span>
    );
}
